<mat-nav-list class="inline-list">
  <a
    mat-list-item
    (click)="select(month)"
    *ngFor="let month of months"
    [ngClass]="month.selected ? 'selected' : ''"
  >
    {{ month.abrev }}
  </a>
</mat-nav-list>
